/* eslint-disable no-loop-func */
import {
  CREATE_TICKET_NOTE,
  CREATE_TICKET_NOTE_COMPLETE,
  CREATE_TICKET_NOTE_ERROR,
  DOWNLOAD_TICKET_ATTACHMENT,
  DOWNLOAD_TICKET_ATTACHMENT_COMPLETE,
  GET_TICKET_ATTACHMENT_INFO,
  GET_TICKET_ATTACHMENT_INFO_COMPLETE,
  GET_TICKET_ATTACHMENT_INFO_ERROR,
} from "modules/ticket/actions/ticketActions";
import AuthFetch from "../auth/AuthFetch";
import type { Middleware } from "@reduxjs/toolkit";

const apiEndpoint = `${import.meta.env.API_ENDPOINT}/api/Ticket`;
const downloadEndpoint = `${import.meta.env.API_ENDPOINT}/api/attachments`;

export function getFilenameFromContentDisposition(
  contentDisposition: string,
): string | undefined {
  const encodedFileName = contentDisposition.match(
    /(?:^|;)\s*filename\*\s*=\s*([^;]+)/i,
  )?.[1];
  if (encodedFileName) {
    try {
      return decodeURIComponent(
        encodedFileName.replace(/^UTF-8'[^']*'/i, "").replace(/^"|"$/g, ""),
      );
    } catch {}
  }

  return contentDisposition.match(
    /(?:^|;)\s*filename\s*=\s*"?([^";]+)"?/i,
  )?.[1];
}

const ticketApi: Middleware = (store) => (next) => (action) => {
  next(action);
  switch (action.type) {
    case GET_TICKET_ATTACHMENT_INFO: {
      AuthFetch(fetch, `${downloadEndpoint}/ticket/${action.payload.data}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log(data, data.status)
          if (data.status && data.status !== 200) {
            return next({
              type: GET_TICKET_ATTACHMENT_INFO_ERROR,
              payload: {
                data: action.payload.data,
              },
            });
          }
          return next({
            type: GET_TICKET_ATTACHMENT_INFO_COMPLETE,
            payload: {
              data: data,
            },
          });
        })
        .catch(() => {
          return next({
            type: GET_TICKET_ATTACHMENT_INFO_ERROR,
            payload: {
              data: action.payload.data,
            },
          });
        });
      break;
    }
    case DOWNLOAD_TICKET_ATTACHMENT: {
      let fileName = "";
      AuthFetch(fetch, `${downloadEndpoint}/download/${action.payload.data}`, {
        method: "GET",
      })
        .then(function (resp) {
          for (const entry of resp.headers.entries()) {
            if (entry[0] === "content-disposition") {
              fileName = getFilenameFromContentDisposition(entry[1]) ?? "";
            }
          }
          return resp.blob();
        })
        .then(function (blob) {
          const link = window.document.createElement("a");

          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          link.remove();
        })
        .then(() => {
          return next({
            type: DOWNLOAD_TICKET_ATTACHMENT_COMPLETE,
            payload: {
              data: action.payload.data,
            },
          });
        });
      break;
    }
    case CREATE_TICKET_NOTE: {
      AuthFetch(fetch, `${apiEndpoint}/ticketnote`, {
        method: "POST",
        body: JSON.stringify(action.payload.data),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          return next({
            type: CREATE_TICKET_NOTE_COMPLETE,
            payload: {
              data: data,
            },
          });
        })
        .catch((err) => {
          return next({
            type: CREATE_TICKET_NOTE_ERROR,
            payload: {
              data: err,
            },
          });
        });
      break;
    }
    default:
      return store;
  }
};

export default ticketApi;
